export default {
  en: {
    liveEvent: {
      welcome:
        "Today’s session is a guide for completing the online workshop at another time and at your leisure.",
      access: "Access the online workshop at ",
      why: "Why complete the workshop?",
      reason1:
        "The MTP plans for billions of dollars in transportation improvements in the El Paso region, including parts of Doña Ana and Otero counties in New Mexico.",
      reason2:
        "The community should have a say in its own transportation infrastructure.",
      scout:
        "Enjoy the meeting from here and submit your comments using the “Comment” button on this page. Or, click “Join Meeting” and have access to the chat room and voice interactivity.",
      ie:
        "Internet Explorer is not the recommended browser for today’s meeting. Paste this web address into any other browser for the best experience: ",
      join: "Join Meeting",
      comment: "Comment",
      name: "Name",
      submit: "Submit",
      info: "Information",
      success:
        "Your comment is received! We will address comments during the Q&A portion of the meeting",
      failure: "Something went wrong, please try again or refresh the page"
    },
    message: {
      // reused
      footer:
        "You are currently using English. Click the button to change the language.",
      survey: "SURVEY",
      moreInfo: "More Info",
      Workshop: "Workshop",
      zipCode: "zip code",
      continue: "continue",
      surveyEndDate: "The survey will be available on Monday, June 15th.",
      RadioGroupYesLabel: "Yes",
      RadioGroupNoLabel: "No",
      CriteriaBtn: "14 Criteria",
      CriteriaDialogTitle: "EVALUATION CRITERIA",
      submit: "Submit",
      ClearBtn: "Clear",
      SuccessSubmit: "You have successfully submitted your response!",
      ErrorSubmit: "Something went wrong, please try again or refresh the page",

      // Header
      headerText: "El Paso MPO On-Demand Virtual Workshop",
      // Footer
      footerText: "One Region. One Voice. One Strategy.",

      // Slide One
      slideOneTitle: "Public Visioning On-Demand Workshop",
      slideOneDateRange: "June 14 through July 19",
      slideOneSubTitle:
        "Tell us your thoughts for the future of transportation in the El Paso region.",
      slideOneEnableAudio: "Enable your audio to hear the host",
      slideOneBrowserSupport:
        "The following browsers are recommended for the workshop: <br /> Chrome, Firefox, Safari, or Edge <br /><br /> Internet Explorer is NOT recommended <br /><br /> If you are experiencing technical issue and unable to fully participate in the virtual workshop, or if you have special accommodations or language needs, please contact us no later than July 1, 2020. Every reasonable effort will be made to accommodate your needs.",

      // Slide Two
      slideTwoTitle: "A Message from the Executive Director",
      slideTwoWorkshopAccess: "- Access to on-demand workshop",
      slideTwoWorkshopEndDate: "July 19",
      slideTwoWorkshopEndDateComment:
        "- Comment period ends at 11:59 pm MT on July 19, 2020.",
      slideTwoWorkshopAlternate:
        "Instead of participating in a workshop, the survey is an alternate way for giving input. People should participate in a workshop or complete the survey (not both).",
      surveyDownloadMessage: "Download Survey PDF",

      // Slide Three
      slideThreeTitle: "Background",
      slideThreeDetails:
        'Click on the "More Info" button to learn more about the El Paso MPO and about the RMS 2050 MTP. Or, click the "Workshop" button to advance to the visioning workshop exercises.',

      // Slide Four
      slideFourPanelOneTitle: "About the El Paso MPO",
      slideFourPanelOneDetails:
        "<li><p>An MPO is a “forum for cooperative transportation decision-making for the metropolitan area.”</p></li><br /><li><p>The El Paso MPO serves El Paso County, southern Dona Ana County and a portion of Otero County</p></li><br /><li><p>The El Paso MPO strives to meet regional transportation needs, while being responsive to community interests and local policies.</p></li><br /><li> <p>Every four years, the MPO is required to develop a long-range metropolitan Transportation Plan (MTP).</p></li>",
      slideFourPanelTwoTitle: "El Paso MPO Jurisdictional Map",
      slideFourPanelThreeTitle: "MTP Background",
      slideFourPanelThreeDetails:
        "<li><p>The current MTP was completed in May 2018 and includes approximately $6 billion of transportation improvements through the life of the plan. The MTP's name is Destino 2045.</p></li><br /><li><p>This MTP update will evaluate how the current plan is working and provide revisions and additions to extend the horizon of the plan to the year 2050. The new MTP name is RMS 2050 (Regional Mobility Strategy)</p></li><li><p>The RMS 2050 could be approved by February of 2022. The MPO's Transportation Policy Board is the approving body.</p></li>",

      // Slide Five
      slideFiveTitle: "Workshop Format",
      slideFiveListTitle: "This workshop is setup in five parts:",
      slideFiveFirstItem: "Tell us about yourself.",
      slideFiveSecondItem:
        "Tell us your thoughts about the current state of the transportation system.",
      slideFiveThirdItem: "Tell us your transportation priorities.",
      slideFiveFourthItem: "Tell us how you think the region is growing.",
      slideFiveFifthItem:
        "Tell us what your needs will be over the next several decades.",

      // Slide Six
      slideSixTitle: "Exercise 1",
      slideSixSubTitle: "Tell us about yourself.",
      slideSixZipCodeQuestion: "What is your zip code?",
      slideSixSelectOneQuestion:
        "Are you a user of any of the following transportation modes and services?",
      slideSixSelectOneLabel: "Transportation modes and services",
      slideSixSelectOneChoices: [
        {
          label: "Private car / SUV / pickup user",
          value: "Private car / SUV / pickup user"
        },
        {
          label: "Pedestrian facility user (sidewalks, hike, and bike trails)",
          value: "Pedestrian facility user (sidewalks, hike, and bike trails)"
        },
        {
          label: "Airport User",
          value: "Airport User"
        },
        {
          label: "Bicycle User",
          value: "Bicycle User"
        },
        {
          label: "Public Transit user of Sun Metro",
          value: "Public Transit user of Sun Metro"
        },
        {
          label: "Intercity bus or rail user",
          value: "Intercity bus or rail user"
        },
        {
          label: "User of transit for the elderly or disabled",
          value: "User of transit for the elderly or disabled"
        },
        {
          label: "Public transit user of El Paso County Transit or SCRTD",
          value: "Public transit user of El Paso County Transit or SCRTD"
        },
        {
          label: "None of the above",
          value: "None of the above"
        }
      ],
      slideSixSelectTwoQuestion:
        "Are you a representative of any of the following types of agencies?",
      slideSixSelectTwoLabel: "Agencies",
      slideSixSelectTwoChoices: [
        {
          label:
            "Representative of agency responsible for transportation safety",
          value:
            "Representative of agency responsible for transportation safety"
        },
        {
          label: "Representative of a law enforcement agency",
          value: "Representative of a law enforcement agency"
        },
        {
          label:
            "Representative of agency responsible for environmental protection",
          value:
            "Representative of agency responsible for environmental protection"
        },
        {
          label: "Representative of agency responsible for traffic control",
          value: "Representative of agency responsible for traffic control"
        },
        {
          label: "Representative of agency responsible for land use management",
          value: "Representative of agency responsible for land use management"
        },
        {
          label: "Representative of agency supporting ride-sharing",
          value: "Representative of agency supporting ride-sharing"
        },
        {
          label:
            "Representative of agency responsible for historic preservation",
          value:
            "Representative of agency responsible for historic preservation"
        },
        {
          label: "Representative of agency responsible for natural resources",
          value: "Representative of agency responsible for natural resources"
        },
        {
          label: "Representative of agency responsible for energy conservation",
          value: "Representative of agency responsible for energy conservation"
        },
        {
          label: "Representative of agency that regulates public parking",
          value: "Representative of agency that regulates public parking"
        },
        { label: "None of the above", value: "None of the above" }
      ],
      slideSixSelectThreeQuestion:
        "Are you a member of the following types of interest groups?",
      slideSixSelectThreeLabel: "Interest groups",
      slideSixSelectThreeChoices: [
        {
          label: "Member of community group (neighborhood association, civic club)",
          value: "Member of community group (neighborhood association, civic club)"
        },
        {
          label: "Member of environmental protection organization",
          value: "Member of environmental protection organization"
        },
        {
          label: "Member of historic or cultural preservation organization",
          value: "Member of historic or cultural preservation organization"
        },
        { label: "None of the above", value: "None of the above" }
      ],
      slideSixSelectFourQuestion:
        "Are you a transportation service / freight provider?",
      slideSixSelectFourLabel: "Transportation service / freight provider",
      slideSixSelectFourChoices: [
        { label: "Transit Operator", value: "Transit Operator" },
        {
          label: "Private Transportation Provider (taxis, bus, etc.)",
          value: "Private Transportation Provider (taxis, bus, etc.)"
        },
        {
          label: "Freight handler or company owner",
          value: "Freight handler or company owner"
        },
        { label: "Airport operator", value: "Airport operator" },
        { label: "None of the above", value: "None of the above" }
      ],
      slideSixSelectFiveQuestion: "Are you a government employee / official?",
      slideSixSelectFiveLabel: "Government employee / official",
      slideSixSelectFiveChoices: [
        {
          label: "City or County elected official",
          value: "City or County elected official"
        },
        {
          label: "Planning organization member",
          value: "Planning organization member"
        },
        { label: "Tribal Official", value: "Tribal Official" },
        { label: "None of the above", value: "None of the above" }
      ],
      slideSixSelectSixQuestion:
        "Do you belong to any of these other stakeholder types?",
      slideSixSelectSixLabel: "Other stakeholder types",
      slideSixSelectSixChoices: [
        { label: "Business owner", value: "Business owner" },
        {
          label: "Responsible for transportation of children",
          value: "Responsible for transportation of children"
        },
        {
          label:
            "Member of population that is traditionally under-served by transportation system",
          value:
            "Member of population that is traditionally under-served by transportation system"
        },
        { label: "None of the above", value: "None of the above" }
      ],

      // Slide Seven
      slideSevenTitle:
        "Travel along a transportation system relies heavily on where people live, work, go to school and play.",
      slideSevenMapInstructions:
        "Please click the icon (do not drag), then click on map to place:",
      slideSevenMapIconLabels: "Home |&nbsp; Work |&nbsp; School |&nbsp; Play",

      // Slide Eight
      slideEightTitle: "Exercise 2",
      slideEightSubTitle:
        "Tell us your thoughts about the current state of the transportation system.",

      slideEightRadioGroupQuestion:
        "If the existing transportation system remains the same over the next 27 years, will it be able to meet the needs created by physical,  economic, and / or social changes by 2050?",
      slideEightRadioGroupYesLabel: "Yes",
      slideEightRadioGroupNoLabel: "No",
      slideEightSelectOneQuestion:
        "What types of modes will NOT be served well by the transportation system in 2050 if it remains the same over the next 27 years?",
      slideEightSelectOneLabel: "Types of Modes",
      slideEightSelectOneChoices: [
        { label: "Bicycles", value: "Bicycles" },
        { label: "Pedestrians", value: "Pedestrians" },
        { label: "Personal automobiles", value: "Personal automobiles" },
        { label: "Buses", value: "Buses" },
        { label: "Freight trucks", value: "Freight trucks" },
        { label: "Airplanes", value: "Airplanes" },
        { label: "Freight rail", value: "Freight rail" },
        { label: "None of the above", value: "None of the above" },
        { label: "Other", value: "Other" }
      ],
      slideEightSelectTwoQuestion:
        "What types of trip purposes within the region will NOT be served well by the transportation system if it remains the same over the next 27 years?",
      slideEightSelectTwoLabel: "Trip Purposes",
      slideEightSelectTwoChoices: [
        { label: "Job commutes", value: "Job commutes" },
        {
          label: "Trips to/from schools and universities",
          value: "Trips to/from schools and universities"
        },
        {
          label: "Trips for everyday errands (e.g. grocery, childcare, etc.)",
          value: "Trips for everyday errands (e.g. grocery, childcare, etc.)"
        },
        { label: "Recreational trips", value: "Recreational trips" },
        {
          label: "Medical trips (doctor's appointments)",
          value: "Medical trips (doctor's appointments)"
        },
        { label: "Entertainment trips", value: "Entertainment trips" },
        {
          label: "Emergency response trips (police, EMS)",
          value: "Emergency response trips (police, EMS)"
        },
        { label: "Social trips", value: "Social trips" },
        { label: "Cross-border trips", value: "Cross-border trips" },
        {
          label: "Business trips (meetings, conferences)",
          value: "Business trips (meetings, conferences)"
        },
        {
          label: "Service trips (plumbers, electricians)",
          value: "Service trips (plumbers, electricians)"
        },
        { label: "None of the above", value: "None of the above" }
      ],
      slideEightSelectThreeQuestion:
        "Which types of users will NOT be served well by the transportation system if it remains the same over the next 27 years?",
      slideEightSelectThreeLabel: "Types of Users",
      slideEightSelectThreeChoices: [
        { label: "Elderly people", value: "Elderly people" },
        {
          label: "Low income individuals / families",
          value: "Low income individuals / families"
        },
        { label: "Disabled people", value: "Disabled people" },
        { label: "Bicycle users", value: "Bicycle users" },
        { label: "Pedestrians", value: "Pedestrians" },
        {
          label: "People with medical needs",
          value: "People with medical needs"
        },
        {
          label: "Car / SUV / pickup drivers",
          value: "Car / SUV / pickup drivers"
        },
        { label: "Children", value: "Children" },
        { label: "Transit users", value: "Transit users" },
        { label: "Minorities", value: "Minorities" },
        {
          label: "Tourists / new community members",
          value: "Tourists / new community members"
        },
        { label: "Unemployed people", value: "Unemployed people" },
        {
          label: "International visitors",
          value: "International visitors"
        },
        { label: "Freight carriers", value: "Freight carriers" },
        { label: "None of the above", value: "None of the above" },
        { label: "Other", value: "Other" }
      ],

      // Slide Nine
      slideNineTitle:
        "Tell us your thoughts about the current state of the transportation system. Part 2.",
      slideNineMapInstructions:
        "Use the map on this page tell us about your concerns or give an idea. The map is interactive and allows you to place a pin at the location or locations that you want to give input about.",
      slideNinePinCommentInstructions:
        "These are comment fields for pins you place down:",
      slideNinePinCommentFieldLabel: "Point location",
      slideNineExtraCommentsCheckText:
        "If you have a comment that is not specific to any place on the map, then check this box and add your general comment into the appropriate text field",
      slideNineCommentFieldOne: "Roadways Comment",
      slideNineCommentFieldTwo: "Safety Comment",
      slideNineCommentFieldThree: "Regional Mobility Comment",
      slideNineCommentFieldFour: "Public Transportation/Mass Transit Comment",
      slideNineCommentFieldFive:
        "Active Transportation (Hiking, Biking, Pedestrian) Comment",
      slideNineScriptTextBtnPartOne: "Click Here",
      slideNineScriptTextBtnPartTwo: "For Audio Text",
      slideNineScriptTextPartOne:
        "Think about changes to the region over the last 5 or 10 years. Those changes might include environmental changes; economic changes, population changes; shared mobility changes. Think about how the Covid-19 virus has changed the way we shop, how we travel, how we do business, and so on. Think about our international ports and the changes we've seen there in terms of traffic or in terms of attitudes and policies that have affected the movement of people and goods at the border. And what about land use changes such as certain parts of town that have grown rapidly and how that growth has affected roadway safety, congestion, perhaps the need for more connecting streets or the need to reconfigure streets. Think about the freight trucks that travel through the region every day and how it affects travel safety or congestion or roadway maintenance. Think about mass transit changes, such as the new streetcar system or the Brio bus rapid transit system. Think about hiking and biking and pedestrian facilities. Think about the age of Interstate 10 and the plan to rebuild it through our region within the next 10 years, and how that long-term reconstruction work will affect travel for the region's residents. When thinking about these things, ask youself: Are there any users of the transportation system who will be poorly served if there are no improvements or changes to the current system?",
      slideNineScriptTextPartTwo:
        "Take your time. Maybe talk about these things with your significant other. Maybe think about travel innovatives you've seen in other cities and how it can be applied here. Then, use the map on this page tell us about your concerns and/or give your ideas. In addition to the map (or instead of the map), you can also type into fields found at the bottom of the page. Scroll down.",

      // Slide Tebn
      slideTenTitle: "Exercise 3",
      slideTenSubTitle:
        "The following is a list of 14 visioning evaluation criteria that will help the El Paso MPO establish priorities for transportation improvements and chart a course for meeting the community's vision.",
      slideTenSliderDetails: "(1: Least important, 5: Most important)",
      slideTenCriteriaDetails:
        "You can view the 14 criteria and the FAST Act Planning Factors by clicking the respective buttons below.",
      slideTenImproveSafety: "Improve Safety",
      slideTenImproveSecurity: "Improve Security",
      slideTenProtectEnvironment: "Protect Environment",
      slideTenReduceCongestion: "Reduce Congestion",
      slideTenPromoteEfficiency: "Promote Efficiency",
      slideTenEconomicGoals: "Support Economic Development Goals",
      slideTenLandGoals: "Support Land Use Goals",
      slideTenIncreaseConnection: "Increase Connection",
      slideTenImproveAccess: "Improve Access",
      slideTenConnectTravel: "Connect Travel",
      slideTenConserveEnergy: "Conserve Energy",
      slideTenImproveQOL: "Improve Quality of Life",
      slideTenModalOptions: "Increase Multi-Modal Options",
      slideTenPreserveROW: "Preserve Rights-of-Way",
      //Slide Ten 14 Critera Component
      slideTenCriteriaBulletOne:
        "IMPROVE SAFETY: Safety is defined as protection against unintentional harm, such as tripping or falling.",
      slideTenCriteriaBulletTwo:
        "PROMOTE EFFICIENCY: Efficiency is characterized by improved system management, the preservation of the existing transportation system, and the reduction in costs.",
      slideTenCriteriaBulletThree:
        "IMPROVE SECURITY: Security is defined as protection against intentional harm, such as crime or sabotage.",
      slideTenCriteriaBulletFour:
        "SUPPORT ECONOMIC DEVELOPMENT GOALS: The economic development goals of the community are defined by the local plans and can be impacted by many factors, one of which is the transportation system. Economic development goals may include enabling global competitiveness, productivity, and efficiency.",
      slideTenCriteriaBulletFive:
        "PROTECT THE ENVIRONMENT: In the urbanized area, important environmental protection issues are maintenance of clean air and flood protection.",
      slideTenCriteriaBulletSix:
        "SUPPORT LAND USE GOALS: The land use goals of the community are defined by the comprehensive plans, and by local planning and development ordinances, as well as through a public visioning process.",
      slideTenCriteriaBulletSeven:
        "REDUCE CONGESTION: Congestion is defined as a roadway system operating at speeds below those for which is was designed.",
      slideTenCriteriaBulletEight:
        "INCREASE CONNECTIONS: The connectivity of the street network and circulation system is measured in terms of ease by which people and goods can move to their desired destinations. Connectivity relates not only to the movement of people and goods within the community, but also to external destinations - regional, national, and international.",
      slideTenCriteriaBulletNine:
        "IMPROVE ACCESS: Improving access involves control and management of the entrance and exit points to a transportation facility for people and freight. Improved access is based on a balance between the number of access points and the efficient movement of traffic through the transportation facility.",
      slideTenCriteriaBulletTen:
        "CONNECT MODES OF TRAVEL: The various modes of travel within the community function best when people and goods can easily move from one mode of travel to another. This inter-modal connectivity is often accomplished by inter-modal transfer facilities.",
      slideTenCriteriaBulletEleven:
        "CONSERVE ENERGY: Energy conservation has become a national priority in recent years and the efficient use of the transportation system can have a dramatic impact on the amount of energy consumed, as well as the corresponding costs - both direct dollar costs and indirect environmental costs - to the community.",
      slideTenCriteriaBulletTwelve:
        "INCREASE MULTI-MODAL OPTIONS: Increasing multi-modal options for the movement of people and goods creates choices. To allow people to choose a more energy efficient or convenient mode of travel, there has to be more than one mode of travel available.",
      slideTenCriteriaBulletThirteen:
        "IMPROVE QUALITY OF LIFE: The quality of life within a community is a term that the community must define for itself. The transportation system can have both positive and negative impacts on the quality of life.",
      slideTenCriteriaBulletFourteen:
        "PRESERVE RIGHTS-OF-WAY: Preservation of rights-of-way refers to purchasing land before development occurs in anticipation of future expansion of the transportation system.",

      // Slide Eleven
      slideElevenTitle: "Exercise 4",
      slideElevenDetails:
        "The next 5 slides will display what the data tells us of recent growth trends. <br /> The data presented has been developed through the year 2045. Please answer the questions that accompany each display. <br /> After the displays, there will be an interactive map that will allow you to give your opinion on where you think growth is taking place in the region.",

      // generic Exercise 4
      Exercise4RadioGroupNoOpinionLabel: "I have no opinion",
      Exercise4SelectOneChoices: [
        {
          label: "New Mexico",
          value: "NewMexicoPopulation"
        },
        {
          label: "West Valley",
          value: "WestValleyPopulation"
        },
        {
          label: "Northeast El Paso",
          value: "NorthEastPopulation"
        },
        {
          label: "Central El Paso",
          value: "CentralPopulation"
        },
        {
          label: "Central East El Paso",
          value: "CentralEastPopulation"
        },
        {
          label: "Mission Valley",
          value: "MissionValleyPopulation"
        },
        {
          label: "Far East El Paso / El Paso County",
          value: "FarEastPopulation"
        }
      ],
      Exercise4SelectTwoChoices: [
        "Higher throughout the subarea",
        "Dispersed differently within the subarea",
        "Lower throughout the subarea"
      ],
      Exercise4RadioGroupPositiveLabel: "Positive",
      Exercise4RadioGroupNegativeLabel: "Negative",

      // Slide Twelve
      slideTwelveContext:
        "The El Paso MPO planning area is expected to gain an additional 400,000 people through the year 2045. This map displays where that population growth is expected to be concentrated.",
      slideTwelveQuestionOne:
        "In your opinion, does this map accurately display population growth trends?",
      slideTwelveSelectOneQuestion:
        'If you answered "no" above, please select all subareas of the region where you think population growth is inaccurate',
      slideTwelveSelectTwoQuestionPartOne: "If you choose",
      slideTwelveSelectTwoQuestionPartTwo: ", for the",
      slideTwelveSelectTwoQuestionPartThree:
        "subarea, which of the following trends do you think best reflects future population growth?",
      slideTwelveRadioGroupQuestion:
        "In your opinion, do you believe that population changes in the region will have a positive or negative effect on the transportation system?",

      // Slide Thirteen
      slideThirteenContext:
        "The El Paso MPO planning area is expected to gain an additional 160,000 jobs through the year 2045. This map displays where that employment growth is expected to be concentrated.",
      slideThirteenQuestionOne:
        "In your opinion, does this map accurately display employment growth trends?",
      slideThirteenSelectOneQuestion:
        'If you answered "no" above, please select all subareas of the region where you think employment growth is inaccurate',
      slideThirteenSelectTwoQuestionPartOne: "If you choose",
      slideThirteenSelectTwoQuestionPartTwo: ", for the",
      slideThirteenSelectTwoQuestionPartThree:
        "subarea, which of the following trends do you think best reflects future employment growth?",
      slideThirteenRadioGroupQuestion:
        "In your opinion, do you believe that employment changes in the region will have a positive or negative effect on the transportation system?",

      // Slide Fourteen
      slideFourteenContext:
        "The following map shows expected traffic volumes compared to the capacity of current streets and highways if the population and employment growth shown in the previous two maps is realized.",
      slideFourteenQuestionOne:
        "Do you believe that this map accurately shows expected areas of roadway congestion?",
      slideFourteenSelectOneQuestion:
        'If you answered "no" above, please select ALL subareas of the region where you think future congestion will differ from what is shown on the map.',
      slideFourteenSelectTwoQuestionPartOne: "If you choose",
      slideFourteenSelectTwoQuestionPartTwo: ", for the",
      slideFourteenSelectTwoQuestionPartThree:
        "subarea, which of the following trends do you think best reflects future future congestion?",

      // Slide Fifteen
      slideFifteenContext:
        "The following map shows existing and planned transit routes for Sun Metro, El Paso County Transit, and South Central Regional Transit District.",
      slideFifteenQuestionOne:
        "Do you think these routes serve the transit needs the region will have in 2050?",
      slideFifteenSelectOneQuestion:
        'If you answered "no" above, please select ALL subareas of the region where you think existing transit is insufficient or where future transit needs will occur.',

      // Slide Sixteen
      slideSixteenContext:
        "The following map shows existing bicycle and major pedestrian facilities, as well as the planned active transportation network.",
      slideSixteenQuestionOne:
        "Do these current and planned facilities serve the non-motorized transportation needs of the region through 2050?",
      slideSixteenSelectOneQuestion:
        'If you answered "no" above, please select ALL subareas of the region where you think existing or planned active transportation facilities will be needed',

      // Slide Seventeen
      slideSeventeenTitle: "Exercise 5",
      slideSeventeenSubTitle: "Tell us where you think the region is in need.",
      slideSeventeenInstructions:
        "Please mark on the map to identify any areas of need that you believe should be addressed as the transportation system changes over the next 27 years. As you are marking the map, please review the list of 14 criteria and look at a list of the established FAST Act Planning Factors to ensure you have considered all possible aspects.",
      slideSeventeenPlanningFactorsBtn: "Planning Factors",
      slideSeventeenPlanningFactorsDialogTitle: "FAST ACT PLANNING FACTORS",
      slideSeventeenPlanningFactorsDialogDetails:
        "Fixing America’s Surface Transportation Act (FAST Act), signed into law in 2015, requires the metropolitan transportation planning process to be continuous, cooperative, and comprehensive, and provide for the consideration and implementation of projects, strategies, and services that will address the following planning factors:",
      // Slide Seventeen Planning Factors
      slideSevenTeenPlanningFactorsOne:
        "Support the economic vitality of the metropolitan area, especially by enabling global competitiveness;",
      slideSevenTeenPlanningFactorsTwo:
        "Increase the safety of the transportation system for motorized and nonmotorized users;",
      slideSevenTeenPlanningFactorsThree:
        "Increase the security of the transportation system for motorized and nonmotorized users;",
      slideSevenTeenPlanningFactorsFour:
        "Increase accessibility and mobility of people and freight;",
      slideSevenTeenPlanningFactorsFive:
        "Protect and enhance the environment, promote energy conservation, improve the quality of life, and promote consistency between transportation improvements and State and local planned growth and economic development patterns;",
      slideSevenTeenPlanningFactorsSix:
        "Enhance the integration and connectivity of the transportation system, across and between modes, for people and freight;",
      slideSevenTeenPlanningFactorsSeven:
        "Promote efficient system management and operation; and",
      slideSevenTeenPlanningFactorsEight:
        "Emphasize the preservation of the existing transportation system.",
      slideSevenTeenPlanningFactorsNine:
        "Improve resiliency and reliability of the transportation system and reduce or mitigate stormwater impacts of surface transportation.",
      slideSevenTeenPlanningFactorsTen: "Enhance travel and tourism.",

      // Slide Eighteen
      slideEighteenTitle: "The following map shows the overall El Paso region.",
      slideEighteenRadioGroupQuestion:
        "Are there any other types of needs in the region that should be addressed by 2050?",
      slideEighteenSelectOneQuestion:
        'If you answered "yes" above, please select ALL the subareas of the region where you think have needs that should be addressed by 2050.',
      slideEighteenSelectOneChoices: [
        {
          label: "Region-wide",
          value: "RegionWideNeeds",
          num: 1
        },
        {
          label: "New Mexico",
          value: "NewMexicoNeeds",
          num: 2
        },
        {
          label: "West Valley",
          value: "WestValleyNeeds",
          num: 3
        },
        {
          label: "Northeast El Paso",
          value: "NorthEastNeeds",
          num: 4
        },
        {
          label: "Central El Paso",
          value: "CentralNeeds",
          num: 5
        },
        {
          label: "Central East El Paso",
          value: "CentralEastNeeds",
          num: 6
        },
        {
          label: "Mission Valley",
          value: "MissionValleyNeeds",
          num: 7
        },
        {
          label: "Far East El Paso / El Paso County",
          value: "FarEastNeeds",
          num: 8
        }
      ],
      slideEighteenSelectTwoQuestionPartOne: "If you chose",
      slideEighteenSelectTwoQuestion:
        "what types of needs should be addressed region-wide?",
      slideEighteenSelectTwoLabelPartOne: "what types of needs does the",
      slideEighteenSelectTwoLabelPartTwo: "have?",
      slideEighteenSelectTwoChoices: [
        { label: "Congestion", value: "Congestion" },
        { label: "Pedestrian access", value: "Pedestrian access" },
        { label: "Bicycle access", value: "Bicycle access" },
        { label: "Intercity rail", value: "Intercity rail" },
        { label: "Safety", value: "Safety" },
        {
          label: "Transit availability / service quality",
          value: "Transit availability / service quality"
        },
        { label: "Intercity bus", value: "Intercity bus" },
        {
          label: "Additional border crossings",
          value: "Additional border crossings"
        },
        {
          label: "Rights-of-way preservation",
          value: "Rights-of-way preservation"
        },
        {
          label: "Border crossing access / expansion",
          value: "Border crossing access / expansion"
        },
        { label: "Ride hailing services", value: "Ride hailing services" },
        {
          label: "Stormwater management / drainage",
          value: "Stormwater management / drainage"
        },
        { label: "Air travel", value: "Air travel" },
        {
          label: "Land use - transportation coordination",
          value: "Land use - transportation coordination"
        },
        { label: "Freight facility access", value: "Freight facility access" },
        { label: "Other", value: "Other" },
        { label: "None of the above", value: "None of the above" }
      ],

      // Slide Nineteen
      slideNineteenTitle:
        "Use this text field to tell us about any other changes you think are needed to the transportation system.",
      slideNineteenTextAreaLabel: "Tell us your needs",

      // Slide Twenty
      slideTwentyTitle: "You are finished!",
      slideTwentyCompleteWorkshopInstructions:
        'To submit your input, please click "Complete Workshop."',
      slideTwentyHowWasExperienceInfo:
        "Let us know how the workshop experience was for you.",
      slideTwentyHowWasExperienceBtn: "How was your experience",

      slideTwentyExtraCommentTitle: "Submit Other Comments or Questions",
      slideTwentyEmail: "Email",
      slideTwentyMail: "Mail - El Paso MPO, Attention:",
      slideTwentyPhone: "Phone",
      slideTwentyLastBullet:
        "Or, submit your comment/question using the text field below.",

      slideTwentyCompleteWorkshopBtn: "Complete Workshop",
      // CommentForm
      slideTwentyOptInLabel:
        "I would like to provide my information to be contacted in the future by the El Paso MPO.",
      slideTwentyWillNotShareText:
        "Information you provide will not be shared.",
      slideTwentyCommentFieldLabel: "Comment",
      slideTwentyFirstNameLabel: "First Name",
      slideTwentyLastNameLabel: "Last Name",
      slideTwentyEmailLabel: "Email",
      slideTwentyPhoneLabel: "Phone",
      slideTwentyAddressLabel: "Address",
      // How was experience
      slideTwentyCommentLabel: "Comment here",
      slideTwentyQuestionOne:
        "Technical issues were a problem and inhibited my participation.",
      slideTwentyQuestionOneHint: "Technical issues comment",
      slideTwentyQuestionTwo:
        "Workshop format was easy to follow. (1: Strongly Disagree, 5: Strongly Agree)",
      slideTwentyQuestionThree:
        "Purpose for this workshop was made clear to me. (1: Strongly Disagree, 5: Strongly Agree)",
      slideTwentyQuestionFour: "How did you find out about this workshop?",
      slideTwentyQuestionFourSelectChoices: [
        { label: "Email", value: "Email" },
        { label: "Word of Mouth", value: "Word of Mouth" },
        {
          label: "Through an elected offiical",
          value: "Through an elected offiical"
        },
        { label: "A flyer", value: "A flyer" },
        { label: "Twitter", value: "Twitter" },
        { label: "Facebook", value: "Facebook" },
        { label: "Newspaper", value: "Newspaper" },
        { label: "Radio", value: "Radio" },
        { label: "TV", value: "TV" }
      ],
      slideTwentyQuestionFourSelectHint: "How did you hear?",
      slideTwentyQuestionFourCommentHint: "How else did you hear",
      slideTwentyQuestionFive:
        "Information and data provided during the workshop was helpful. (1: Strongly Disagree, 5: Strongly Agree)",
      slideTwentyQuestionSix:
        "Do you have a suggestion that can improve our outreach for public participation or that can improve the workshop itself?",
      slideTwentyQuestionSixCommentHint: "Suggested improvements comment",
      standAloneSurvey: "Go To Digital Survey"
    }
  },
  es: {
    liveEvent: {
      welcome:
        "La sesión de hoy es una guía para completar el taller en línea en otro momento y en su tiempo libre.",
      access: "Acceda al taller en línea en ",
      why: "¿Por qué completar el taller?",
      reason1:
        "El MTP planea miles de millones de dólares en mejoras de transporte en la región de El Paso, incluidas partes de los condados de Doña Ana y Otero en Nuevo México.",
      reason2:
        "La comunidad debería tener voz en su propia infraestructura de transporte.",
      scout:
        "Disfruten la reunión desde aquí, y envien sus comentarios usando el botón de “Comentar” en esta página.  O pueden hacer clic en “Unirse a la reunion”, la cual les dara acceso al chat e interaccion de voz.",
      ie:
        "Internet Explorer no es el navegador recomendado para la reunión de hoy. Pegue esta dirección web en cualquier otro navegador para obtener la mejor experiencia: ",
      join: "Unirse a la reunion",
      name: "Nombre",
      comment: "Comentario",
      submit: "Enviar",
      info: "Información",
      success:
        "Tu comentario ha sido recibido! Abordaremos los comentarios durante la sección de preguntas y respuestas de la reunión",
      failure:
        "Algo salió mal, por favor intente nuevamente o actualice la página"
    },
    message: {
      // reused
      footer:
        "Actualmente estás usando español. Haga clic en el botón para cambiar el idioma.",
      survey: "ENCUESTA",
      moreInfo: "MÁS INFORMACIÓN",
      Workshop: "TALLER",
      zipCode: "Código postal",
      continue: "Continuar",
      surveyEndDate: "The survey will be available on Monday, June 15th.",
      RadioGroupYesLabel: "Sí",
      RadioGroupNoLabel: "No",
      CriteriaBtn: "14 CRITERIOS",
      CriteriaDialogTitle: "CRITERIOS DE EVALUACIÓN",
      submit: "ENVIAR",
      ClearBtn: "Borrar",
      SuccessSubmit: "You have successfully submitted your response!",
      ErrorSubmit: "Something went wrong, please try again or refresh the page",

      // Header
      headerText: "Taller Virtual en Demanda del MPO de El Paso",
      // Footer
      footerText: "UNA REGIÓN. UNA VOZ. UNA ESTRATEGIA.",

      // Slide One
      slideOneTitle: "Taller de Visión Pública en Demanda",
      slideOneDateRange: "Del 14 de junio al 19 de julio",
      slideOneSubTitle:
        "Díganos qué piensa sobre el futuro del transporte en la región de El Paso.",
      slideOneEnableAudio: "Habilite su audio para escuchar al anfitrión.",
      slideOneBrowserSupport:
        "Se recomiendan los siguientes navegadores para el taller: <br /> Chrome, Firefox, Safari o Edge <br /><br /> NO se recomienda Internet Explorer <br /> <br /> Si tiene problemas técnicos y no puede participar plenamente en el taller virtual, o si necesita acomodaciones especiales o de lenguaje, comuníquese con nosotros a más tardar el 1 de julio del 2020. Se harán todos los esfuerzos razonables para satisfacer sus necesidades.",

      // Slide Two
      slideTwoTitle: "Un mensaje del director ejecutivo",
      slideTwoWorkshopAccess: "- Acceso al taller en demanda",
      slideTwoWorkshopEndDate: "19 de julio",
      slideTwoWorkshopEndDateComment:
        "- el período de comentarios termina a las 11:59 p.m. MT el 19 de julio del 2020.",
      slideTwoWorkshopAlternate:
        "En lugar de participar en un taller, la encuesta es otra alternativa para dar su opinión. Las personas deben o participar en un taller o completar la encuesta (no ambas).",
      surveyDownloadMessage: "Descargar encuesta PDF",

      // Slide Three
      slideThreeTitle: "Antecedentes",
      slideThreeDetails:
        'Presione el botón " MÁS INFORMACIÓN " para aprender sobre la Organización de Planeación Metropolitana de El Paso (El Paso MPO, por sus siglas en inglés) y sobre el RMS 2050 MTP. O, presione el botón “Taller" para avanzar a los ejercicios del taller de visión.',

      // Slide Four
      slideFourPanelOneTitle: "Sobre el MPO de El Paso",
      slideFourPanelOneDetails:
        '<li><p>Un MPO es un "foro para la toma de decisiones sobre el transporte en cooperativa para el área metropolitana."</p></li><br /><li><p>El MPO de El Paso sirve el condado de El Paso, el sur del condado de Doña Ana y una parte del condado de Otero</p></li><br /><li><p>El MPO de El Paso se esfuerza por satisfacer las necesidades regionales del transporte, mientras que responde a los intereses de la comunidad y las políticas locales.</p></li><br /><li> <p>Cada cuatro años, se requiere que el MPO desarrolle un Plan de Transporte Metropolitano (MTP, por sus siglas en inglés) de largo plazo.</p></li>',
      slideFourPanelTwoTitle: "Mapa Jurisdiccional del MPO de El Paso",
      slideFourPanelThreeTitle: "Antecedentes del MTP",
      slideFourPanelThreeDetails:
        "<li><p>El MTP actual se completó en mayo del 2018 e incluye aproximadamente $6 mil millones para mejoras del transporte durante la vigencia del plan. El nombre del MTP es Destino 2045.</p></li><br /><li><p>Esta actualización del MTP evaluará cómo está funcionando el plan actual y proporcionará revisiones y adiciones para extender el horizonte del plan hasta el año 2050. El nuevo MTP se llamará Estrategia de Movilidad Regional 2050 (RMS 2050, por sus siglas en inglés)</p></li><li><p>El RMS 2050 podría aprobarse en febrero del 2022. La Junta de Política del Transporte del MPO es el organismo de aprobación.</p></li>",

      // Slide Five
      slideFiveTitle: "Formato del taller",
      slideFiveListTitle: "Este taller está configurado en cinco partes:",
      slideFiveFirstItem: "Cuéntenos acerca de Ud.",
      slideFiveSecondItem:
        "Cuéntenos qué piensa sobre el estado actual del sistema de transporte.",
      slideFiveThirdItem: "Cuéntenos sus prioridades de transporte.",
      slideFiveFourthItem:
        "Cuéntenos cómo piensa que está creciendo la región.",
      slideFiveFifthItem:
        "Cuéntenos cuáles serán sus necesidades en las próximas décadas.",

      // Slide Six
      slideSixTitle: "Ejercicio 1",
      slideSixSubTitle: "Cuéntenos acerca de Ud.",
      slideSixZipCodeQuestion: "¿Cuál es su código postal?",
      slideSixSelectOneQuestion:
        "¿Es usted usuario de alguno de los siguientes modos y servicios de transporte?",
      slideSixSelectOneLabel: "Modos y servicios de transporte",
      slideSixSelectOneChoices: [
        {
          label: "Usuario de automóvil privado / SUV / camioneta",
          value: "Private car / SUV / pickup user"
        },
        {
          label:
            "Usuario de instalaciones peatonales (aceras, caminos y senderos para bicicletas)",
          value: "Pedestrian facility user (sidewalks, hike, and bike trails)"
        },
        {
          label: "Usuario del aeropuerto",
          value: "Airport User"
        },
        {
          label: "Usuario de bicicletas",
          value: "Bicycle User"
        },
        {
          label: "Usuario de transporte público de Sun Metro",
          value: "Public Transit user of Sun Metro"
        },
        {
          label: "Usuario interurbano de autobús o tren",
          value: "Intercity bus or rail user"
        },
        {
          label: "Usuario de transporte para ancianos o discapacitados",
          value: "User of transit for the elderly or disabled"
        },
        {
          label:
            "Usuario de transporte público de tránsito del condado de El Paso o SCRTD",
          value: "Public transit user of El Paso County Transit or SCRTD"
        },
        {
          label: "Nada de lo anterior",
          value: "None of the above"
        }
      ],
      slideSixSelectTwoQuestion:
        "¿Es usted representante de alguno de los siguientes tipos de agencias?",
      slideSixSelectTwoLabel: "Agencias",
      slideSixSelectTwoChoices: [
        {
          label:
            "Representante de una agencia responsable de la seguridad del transporte",
          value:
            "Representative of agency responsible for transportation safety"
        },
        {
          label:
            "Representante de una agencia encargada de la aplicación de la ley",
          value: "Representative of a law enforcement agency"
        },
        {
          label:
            "Representante de una agencia responsable por la protección del medio ambiente",
          value:
            "Representative of agency responsible for environmental protection"
        },
        {
          label:
            "Representante de una agencia responsable por control del tráfico",
          value: "Representative of agency responsible for traffic control"
        },
        {
          label:
            "Representante de una agencia responsable por el manejo del uso del suelo",
          value: "Representative of agency responsible for land use management"
        },
        {
          label: "Representante de una agencia que apoya el viaje compartido",
          value: "Representative of agency supporting ride-sharing"
        },
        {
          label:
            "Representante de la agencia responsable por la preservación histórica",
          value:
            "Representative of agency responsible for historic preservation"
        },
        {
          label:
            "Representante de una agencia responsable de los recursos naturales",
          value: "Representative of agency responsible for natural resources"
        },
        {
          label:
            "Representante de una agencia responsable de la conservación de energía",
          value: "Representative of agency responsible for energy conservation"
        },
        {
          label:
            "Representante de una agencia que regula el estacionamiento público",
          value: "Representative of agency that regulates public parking"
        },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],
      slideSixSelectThreeQuestion:
        "¿Es usted miembro de alguno de los siguientes grupos de interés?",
      slideSixSelectThreeLabel: "Grupos de interés",
      slideSixSelectThreeChoices: [
        {
          label:
            "Miembro de un grupo comunitario (asociación de vecindario, club cívico)",
          value: "Member of community group (neighborhood association, civic club)"
        },
        {
          label: "Miembro de una organización de protección del medio ambiente",
          value: "Member of environmental protection organization"
        },
        {
          label:
            "Miembro de una organización de preservación histórica o cultural",
          value: "Member of historic or cultural preservation organization"
        },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],
      slideSixSelectFourQuestion:
        "¿Es usted un proveedor de servicio de transporte / de carga?",
      slideSixSelectFourLabel: "Proveedor de servicio de transporte / de carga",
      slideSixSelectFourChoices: [
        { label: "Operador de transporte público", value: "Transit Operator" },
        {
          label: "Proveedor de transporte privado (taxi, autobús, etc.)",
          value: "Private Transportation Provider (taxis, bus, etc.)"
        },
        {
          label: "Manejador de carga o propietario de la empresa",
          value: "Freight handler or company owner"
        },
        { label: "Operador de aeropuerto", value: "Airport operator" },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],
      slideSixSelectFiveQuestion:
        "¿Es usted un empleado / funcionario del gobierno?",
      slideSixSelectFiveLabel: "Empleado/funcionario del gobierno",
      slideSixSelectFiveChoices: [
        {
          label: "Funcionario electo de la ciudad o el condado",
          value: "City or County elected official"
        },
        {
          label: "Miembro de la organización de planificación",
          value: "Planning organization member"
        },
        { label: "Funcionario Tribal", value: "Tribal Official" },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],
      slideSixSelectSixQuestion:
        "¿Pertenece usted a alguno de estos otros tipos de grupos interesados?",
      slideSixSelectSixLabel: "Otros tipos de grupos interesados",
      slideSixSelectSixChoices: [
        { label: "Propietario de negocios", value: "Business owner" },
        {
          label: "Responsable por el transporte de niños",
          value: "Responsible for transportation of children"
        },
        {
          label:
            "Miembro de la población que tradicionalmente está insuficientemente servida por el sistema de transporte",
          value:
            "Member of population that is traditionally under-served by transportation system"
        },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],

      // Slide Seven
      slideSevenTitle:
        "Viajar a lo largo de un sistema de transporte depende en gran medida de donde la gente vive, trabaja, va a la escuela y juega.",
      slideSevenMapInstructions:
        "Presione en el icono, luego presione en el mapa para colocar:",
      slideSevenMapIconLabels:
        "Hogar |&nbsp; Trabajo |&nbsp; Escuela |&nbsp; Juego",

      // Slide Eight
      slideEightTitle: "Ejercicio 2",
      slideEightSubTitle:
        "Cuéntenos que piensa sobre el estado actual del sistema de transporte.",

      slideEightRadioGroupQuestion:
        "Si el sistema de transporte existente permanece en las condiciones actuales durante los próximos 27 años, sería capaz de satisfacer las necesidades creadas por cambios físicos, económicos y / o sociales  en el 2050?",
      slideEightRadioGroupYesLabel: "Sí",
      slideEightRadioGroupNoLabel: "No",
      slideEightSelectOneQuestion:
        "¿Qué tipos de modos NO serían bien atendidos por el sistema de transporte en el 2050 si permanece en las condiciones actuales durante los próximos 27 años?",
      slideEightSelectOneLabel: "Tipos de modos",
      slideEightSelectOneChoices: [
        { label: "Bicicletas", value: "Bicycles" },
        { label: "Peatones", value: "Pedestrians" },
        { label: "Automóviles personales", value: "Personal automobiles" },
        { label: "Autobuses", value: "Buses" },
        { label: "Camiones de carga", value: "Freight trucks" },
        { label: "Aviones", value: "Airplanes" },
        { label: "Ferrocarril de carga", value: "Freight rail" },
        { label: "Nada de lo anterior", value: "None of the above" },
        { label: "Otro", value: "Other" }
      ],
      slideEightSelectTwoQuestion:
        "¿Cuáles propósitos de viaje dentro de la región no serían bien atendidos por el sistema de transporte si permanece en las mismas condiciones actuales durante los próximos 27 años?",
      slideEightSelectTwoLabel: "Propósitos de viaje",
      slideEightSelectTwoChoices: [
        { label: "Viajes de trabajo", value: "Job commutes" },
        {
          label: "Viajes hacia/desde escuelas y universidades",
          value: "Trips to/from schools and universities"
        },
        {
          label:
            "Viajes para mandados cotidianos (por ejemplo, supermercados, cuidado de niños, etc.)",
          value: "Trips for everyday errands (e.g. grocery, childcare, etc.)"
        },
        { label: "Viajes recreativos", value: "Recreational trips" },
        {
          label: "Viajes médicos (citas médicas)",
          value: "Medical trips (doctor's appointments)"
        },
        { label: "Viajes de entretenimiento", value: "Entertainment trips" },
        {
          label: "Viajes de servicios de emergencia (policía, EMS)",
          value: "Emergency response trips (police, EMS)"
        },
        { label: "Viajes sociales", value: "Social trips" },
        { label: "Viajes transfronterizos", value: "Cross-border trips" },
        {
          label: "Viajes de negocios (reuniones, conferencias)",
          value: "Business trips (meetings, conferences)"
        },
        {
          label: "Viajes de servicio (plomeros, electricistas)",
          value: "Service trips (plumbers, electricians)"
        },
        { label: "Nada de lo anterior", value: "None of the above" }
      ],
      slideEightSelectThreeQuestion:
        "¿Qué tipos de usuarios no recibirán un buen servicio del sistema de transporte si permanece en las mismas condiciones actuales durante los próximos 27 años?",
      slideEightSelectThreeLabel: "Tipos de usuarios",
      slideEightSelectThreeChoices: [
        { label: "Personas mayores", value: "Elderly people" },
        {
          label: "Individuos / familias de bajos ingresos",
          value: "Low income individuals / families"
        },
        { label: "Personas discapacitadas", value: "Disabled people" },
        { label: "Usuarios de bicicletas", value: "Bicycle users" },
        { label: "Peatones", value: "Pedestrians" },
        {
          label: "Personas con necesidades médicas",
          value: "People with medical needs"
        },
        {
          label: "Conductores de coche / SUV / recogida",
          value: "Car / SUV / pickup drivers"
        },
        { label: "Niños", value: "Children" },
        { label: "Usuarios de tránsito", value: "Transit users" },
        { label: "Minorías", value: "Minorities" },
        {
          label: "Turistas / miembros nuevos de la comunidad",
          value: "Tourists / new community members"
        },
        { label: "Personas desempleadas", value: "Unemployed people" },
        {
          label: "Visitantes internacionales",
          value: "International visitors"
        },
        { label: "Transportistas de carga", value: "Freight carriers" },
        { label: "Nada de lo anterior", value: "None of the above" },
        { label: "Otro", value: "Other" }
      ],

      // Slide Nine
      slideNineTitle:
        "Cuéntenos qué piensa sobre el estado actual del sistema de transporte. Parte 2.",
      slideNineMapInstructions:
        "Use el mapa en esta página para comunicar sus inquietudes o darnos ideas. El mapa es interactivo y le permite colocar un marcador en la ubicación o ubicaciones en donde desea darnos su opinión.",
      slideNinePinCommentInstructions:
        "These are comment fields for pins you place down:",
      slideNinePinCommentFieldLabel: "Point location",
      slideNineExtraCommentsCheckText:
        "Si tiene un comentario que no es específico a ningún lugar en el mapa, entonces marque esta casilla y agregue su comentario general en el campo de texto apropiado.",
      slideNineCommentFieldOne: "Comentario sobre carreteras",
      slideNineCommentFieldTwo: "Comentario sobre seguridad",
      slideNineCommentFieldThree: "Comentario sobre la movilidad regional",
      slideNineCommentFieldFour:
        "Comentario sobre transporte público/ transporte colectivo",
      slideNineCommentFieldFive:
        "Comentario sobre transporte activo (excursionismo, ciclismo, peatonal)",
      slideNineScriptTextBtnPartOne: "Click Here",
      slideNineScriptTextBtnPartTwo: "For Audio Text",
      slideNineScriptTextPartOne:
        "Think about changes to the region over the last 5 or 10 years. Those changes might include environmental changes; economic changes, population changes; shared mobility changes. Think about how the Covid-19 virus has changed the way we shop, how we travel, how we do business, and so on. Think about our international ports and the changes we've seen there in terms of traffic or in terms of attitudes and policies that have affected the movement of people and goods at the border. And what about land use changes such as certain parts of town that have grown rapidly and how that growth has affected roadway safety, congestion, perhaps the need for more connecting streets or the need to reconfigure streets. Think about the freight trucks that travel through the region every day and how it affects travel safety or congestion or roadway maintenance. Think about mass transit changes, such as the new streetcar system or the Brio bus rapid transit system. Think about hiking and biking and pedestrian facilities. Think about the age of Interstate 10 and the plan to rebuild it through our region within the next 10 years, and how that long-term reconstruction work will affect travel for the region's residents. When thinking about these things, ask youself: Are there any users of the transportation system who will be poorly served if there are no improvements or changes to the current system?",
      slideNineScriptTextPartTwo:
        "Take your time. Maybe talk about these things with your significant other. Maybe think about travel innovatives you've seen in other cities and how it can be applied here. Then, use the map on this page tell us about your concerns and/or give your ideas. In addition to the map (or instead of the map), you can also type into fields found at the bottom of the page. Scroll down.",

      // Slide Ten
      slideTenTitle: "Ejercicio 3",
      slideTenSubTitle:
        "Lo siguiente es una lista de 14 criterios de evaluación de visión que ayudarán a el MPO de El Paso a establecer prioridades para mejoras de transporte y trazar un curso para cumplir con la visión de la comunidad.",
      slideTenSliderDetails: "(1: menos importante, 5: más importante)",
      slideTenCriteriaDetails:
        "Puede ver los 14 criterios y los factores de planificación de la ley FAST presionando en los botones correspondientes a continuación.",
      slideTenImproveSafety: "Mejorar el Bienestar",
      slideTenImproveSecurity: "Mejorar la Seguridad",
      slideTenProtectEnvironment: "Proteger el Medio Ambiente",
      slideTenReduceCongestion: "Reducir la Congestión",
      slideTenPromoteEfficiency: "Promover la Eficiencia",
      slideTenEconomicGoals: "Apoyar los Objetivos del Desarrollo Económico",
      slideTenLandGoals: "Apoyar los Objetivos del Uso del Suelo",
      slideTenIncreaseConnection: "Aumentar las Conexiones",
      slideTenImproveAccess: "Mejorar el Acceso",
      slideTenConnectTravel: "Conectar Modos de Viaje",
      slideTenConserveEnergy: "Conservar Energía",
      slideTenImproveQOL: "Mejorar la Calidad de Vida",
      slideTenModalOptions: "Aumentar las Opciones Multimodales",
      slideTenPreserveROW: "Preservar los Derechos de Vía",
      //Slide Ten 14 Critera Component
      slideTenCriteriaBulletOne:
        "MEJORAR EL BIENESTAR: El bienestar se define como protección contra daños involuntarios, como tropiezos o caídas.",
      slideTenCriteriaBulletTwo:
        "PROMOVER LA EFICIENCIA: La eficiencia se caracteriza por una mejor gestión del sistema, la preservación del sistema de transporte existente y la reducción de costos.",
      slideTenCriteriaBulletThree:
        "MEJORAR LA SEGURIDAD: La seguridad se define como protección contra daños intencionales, como delitos o sabotajes.",
      slideTenCriteriaBulletFour:
        "APOYAR LOS OBJETIVOS DE DESARROLLO ECONÓMICO: Los objetivos de desarrollo económico de la comunidad están definidos por los planes locales y pueden verse afectados por muchos factores, uno de los cuales es el sistema de transporte. Los objetivos de desarrollo económico pueden incluir facilitar la competitividad global, la productividad y la eficiencia.",
      slideTenCriteriaBulletFive:
        "PROTEGER EL MEDIO AMBIENTE: En el área urbanizada, cuestiones importantes de protección del medio ambiente son mantener el aire limpio y la protección contra inundaciones.",
      slideTenCriteriaBulletSix:
        "APOYAR LOS OBJETIVOS DE USO DEL SUELO: Los objetivos del uso del suelo de la comunidad están definidos por los planes integrales y por las ordenanzas locales de planificación y desarrollo, así como a través de un proceso de visión pública.",
      slideTenCriteriaBulletSeven:
        "REDUCIR LA CONGESTIÓN: La congestión se define como un sistema de carreteras que funciona a velocidades inferiores para las que fueron diseñadas.",
      slideTenCriteriaBulletEight:
        "AUMENTAR LAS CONEXIONES: La conectividad de la red de calles y el sistema de circulación se mide en términos de facilidad por el cual las personas y las mercancías pueden trasladarse a sus destinos deseados. La conectividad se relaciona no sólo con el movimiento de personas y mercancías dentro de la comunidad, sino también con destinos externos - regionales, nacionales e internacionales.",
      slideTenCriteriaBulletNine:
        "MEJORAR EL ACCESO: Mejorar el acceso implica el control y la gestión de los puntos de entrada y salida a una instalación de transporte para personas y carga. El acceso mejorado se basa en un equilibrio entre el número de puntos de acceso y el movimiento eficiente del tráfico a través de la instalación de transporte.",
      slideTenCriteriaBulletTen:
        "CONECTAR MODOS DE VIAJE: Los diversos modos de viaje dentro de la comunidad funcionan mejor cuando las personas y los bienes pueden moverse fácilmente de un modo de viaje a otro. Esta conectividad intermodal a menudo se logra mediante instalaciones de transferencia intermodal.",
      slideTenCriteriaBulletEleven:
        "CONSERVAR ENERGÍA: La conservación de la energía se ha convertido en una prioridad nacional en los últimos años y el uso eficiente del sistema de transporte puede tener un impacto dramático en la cantidad de energía consumida, así como en los costos correspondientes -tanto los costos directos en dólares como los costos ambientales indirectos- para la comunidad.",
      slideTenCriteriaBulletTwelve:
        "AUMENTAR LAS OPCIONES MULTIMODALES: El aumento de opciones multimodales para el movimiento de personas y bienes crea opciones. Para permitir que las personas elijan un modo de viaje más energéticamente eficiente o conveniente, tiene que haber más de un modo de viaje disponible.",
      slideTenCriteriaBulletThirteen:
        "MEJORAR LA CALIDAD DE VIDA: La calidad de vida dentro de una comunidad es un término que la comunidad debe definir por sí misma. El sistema de transporte puede tener impactos tanto positivos como negativos en la calidad de vida.",
      slideTenCriteriaBulletFourteen:
        "CONSERVAR EL DERECHO DE VÍA: La preservación del derecho de vía se refiere a la compra de tierras antes de que ocurra el desarrollo en previsión de la futura expansión del sistema de transporte.",

      // Slide Eleven
      slideElevenTitle: "Ejercicio 4",
      slideElevenDetails:
        "Las siguientes 5 diapositivas mostrarán lo que los datos nos dicen sobre las tendencias de crecimiento recientes. <br /> Los datos presentados se han desarrollado hasta el año 2045. Responda a las preguntas que acompañan a cada diapositiva. <br /> Después de las diapositivas, habrá un mapa interactivo que le permitirá dar su opinión sobre dónde usted cree que está teniendo lugar el crecimiento en la región.",

      // generic Exercise 4
      Exercise4RadioGroupNoOpinionLabel: "No tengo opinión",
      Exercise4SelectOneChoices: [
        {
          label: "New Mexico",
          value: "NewMexicoPopulation"
        },
        {
          label: "West Valley",
          value: "WestValleyPopulation"
        },
        {
          label: "Northeast El Paso",
          value: "NorthEastPopulation"
        },
        {
          label: "Central El Paso",
          value: "CentralPopulation"
        },
        {
          label: "Central East El Paso",
          value: "CentralEastPopulation"
        },
        {
          label: "Mission Valley",
          value: "MissionValleyPopulation"
        },
        {
          label: "Far East El Paso / El Paso County",
          value: "FarEastPopulation"
        }
      ],
      Exercise4SelectTwoChoices: [
        {
          label: "Mayor crecimiento en toda la subárea",
          value: "Higher throughout the subarea"
        },
        {
          label: "Menor crecimiento en toda la subárea",
          value: "Dispersed differently within the subarea"
        },
        {
          label: "Crecimiento disperso dentro de la subárea",
          value: "Lower throughout the subarea"
        }
      ],
      Exercise4RadioGroupPositiveLabel: "Positivo",
      Exercise4RadioGroupNegativeLabel: "Negativo",

      // Slide Twelve
      slideTwelveContext:
        "Se espera que el área de planificación del MPO de El Paso aumentará 400,000 personas adicionales en el año 2045. Este mapa muestra dónde se espera que se concentre ese crecimiento de la población.",
      slideTwelveQuestionOne:
        "En su opinión, ¿muestra este mapa las tendencias de crecimiento de la población con precisión?",
      slideTwelveSelectOneQuestion:
        "Si usted respondió “no” anteriormente, por favor seleccione todas las subáreas de la región donde usted piensa que el crecimiento de la población está incorrecto en el mapa anterior. ",
      slideTwelveSelectTwoQuestionPartOne: "Si usted respondió",
      slideTwelveSelectTwoQuestionPartTwo: ", para la subárea de ",
      slideTwelveSelectTwoQuestionPartThree:
        ", ¿Cuál de las siguientes tendencias cree usted que mejor refleja el futuro crecimiento de la población?",
      slideTwelveRadioGroupQuestion:
        "En su opinión, ¿cree que los cambios de población en la región tendrán un efecto positivo o negativo sobre el sistema de transporte?",

      // Slide Thirteen
      slideThirteenContext:
        "Se espera que el área de planificación del MPO de El Paso obtendrá 160,000 puestos de trabajo adicionales en el año 2045. Este mapa muestra dónde se espera que se concentre ese crecimiento del empleo",
      slideThirteenQuestionOne:
        "En su opinión, ¿muestra este mapa las tendencias de crecimiento del empleo con precisión?",
      slideThirteenSelectOneQuestion:
        "Si usted respondió “no” anteriormente, por favor seleccione todas las subáreas de la región donde usted piensa que el crecimiento del empleo está incorrecto en el mapa anterior.",
      slideThirteenSelectTwoQuestionPartOne: "Si usted respondió",
      slideThirteenSelectTwoQuestionPartTwo: ", para la subárea de ",
      slideThirteenSelectTwoQuestionPartThree:
        ", ¿Cuál de las siguientes tendencias cree usted que mejor refleja el futuro crecimiento del empleo?",
      slideThirteenRadioGroupQuestion:
        "En su opinión, ¿cree que el crecimiento del empleo en la región tendrá un efecto positivo o negativo sobre el sistema de transporte?",

      // Slide Fourteen
      slideFourteenContext:
        "El siguiente mapa muestra los volúmenes de tráfico esperados en comparación con la capacidad de las calles y carreteras actuales si se realiza el crecimiento de la población y el empleo mostrado en los dos mapas anteriores.",
      slideFourteenQuestionOne:
        "¿Cree que este mapa muestra las áreas donde se espera que haya congestión vial con precisión?",
      slideFourteenSelectOneQuestion:
        "Si usted respondió “no” anteriormente, por favor seleccione TODAS las subáreas de la región donde usted piensa que la congestión vial será diferente de lo que muestra el mapa.",
      slideFourteenSelectTwoQuestionPartOne: "Si usted respondió",
      slideFourteenSelectTwoQuestionPartTwo: ", para la subárea de ",
      slideFourteenSelectTwoQuestionPartThree:
        ", ¿Cuál de las siguientes tendencias cree usted que mejor refleja la futura congestión vial?",

      // Slide Fifteen
      slideFifteenContext:
        "El siguiente mapa muestra las rutas de transporte público existentes y planificadas de Sun Metro, El Paso County Transit y South Central Regional Transit District.",
      slideFifteenQuestionOne:
        "¿Cree que éstas rutas satisfacen las necesidades de transporte público que tendrá la región en el 2050?",
      slideFifteenSelectOneQuestion:
        "Si usted respondió “no” anteriormente, por favor seleccione TODAS las subáreas de la región donde usted piensa que el transporte público existente es insuficiente o donde se producirán futuras necesidades de transporte público.",

      // Slide Sixteen
      slideSixteenContext:
        "El siguiente mapa muestra las instalaciones principales existentes para bicicletas y peatones, así como la red planificada de transporte activo.",
      slideSixteenQuestionOne:
        "¿Cree que las instalaciones actuales y planificadas satisfacen las necesidades de transporte no motorizado de la región hasta el 2050?",
      slideSixteenSelectOneQuestion:
        "Si usted respondió “no” anteriormente, por favor seleccione TODAS las subáreas de la región donde usted piensa que el transporte público existente es insuficiente o donde se producirán futuras necesidades de transporte público.",

      // Slide Seventeen
      slideSeventeenTitle: "Ejercicio 5",
      slideSeventeenSubTitle:
        "Díganos dónde cree que la región tiene necesidades.",
      slideSeventeenInstructions:
        "Marque el mapa para identificar cualquier área de necesidad que usted cree debe abordarse a medida que el sistema de transporte cambia en los próximos 27 años. Al marcar el mapa, revise la lista de 14 criterios y fíjese en la lista de factores de planificación por la ley FAST para asegurarse de que haya considerado todos los aspectos posibles.",
      slideSeventeenPlanningFactorsBtn: "Factores de planificación",
      slideSeventeenPlanningFactorsDialogTitle:
        "FACTORES DE PLANIFICACIÓN DE LA LEY FAST",
      slideSeventeenPlanningFactorsDialogDetails:
        "La Ley Arreglando el Transporte de Superficie de Estados Unidos (FAST, por sus siglas en inglés), firmada en el 2015, requiere que el proceso de planificación del transporte metropolitano sea continuo, cooperativo e integral y que se consideren e implementen proyectos, estrategias y servicios que abordarán los siguientes factores de planificación:",
      // Slide Seventeen Planning Factors
      slideSevenTeenPlanningFactorsOne:
        "Apoyar la vitalidad económica del área metropolitana, especialmente al facilitar la competitividad mundial;",
      slideSevenTeenPlanningFactorsTwo:
        "Aumentar la seguridad del sistema de transporte para usuarios de transporte motorizado y no motorizado;",
      slideSevenTeenPlanningFactorsThree:
        "Aumentar la protección del sistema de transporte para usuarios de transporte motorizado y no motorizado;",
      slideSevenTeenPlanningFactorsFour:
        "Aumentar la accesibilidad y movilidad de personas y carga;",
      slideSevenTeenPlanningFactorsFive:
        "Proteger y mejorar el medio ambiente, promover la conservación de la energía, mejorar la calidad de vida y promover la coherencia entre las mejoras de transporte, el crecimiento estatal y local planificado y los patrones de desarrollo económico;",
      slideSevenTeenPlanningFactorsSix:
        "Mejorar la integración y conectividad del sistema de transporte, a través de y entre los modos, para las personas y el transporte de carga;",
      slideSevenTeenPlanningFactorsSeven:
        "Promover la gestión y operación eficiente del sistema; y",
      slideSevenTeenPlanningFactorsEight:
        "Enfatizar la preservación del sistema de transporte existente.",
      slideSevenTeenPlanningFactorsNine:
        "Mejorar la resistencia y la confiabilidad del sistema de transporte y reducir o mitigar los impactos de las aguas pluviales causados por el transporte de superficie.",
      slideSevenTeenPlanningFactorsTen: "Mejorar los viajes y el turismo.",

      // Slide Eighteen
      slideEighteenTitle: "El siguiente mapa muestra la región de El Paso.",
      slideEighteenRadioGroupQuestion:
        "¿Existen otros tipos de necesidades en la región que deben ser abordadas para el 2050?",
      slideEighteenSelectOneQuestion:
        "Si usted respondió “yes” anteriormente, por favor seleccione TODAS las subáreas de la región donde usted piensa que haya necesidades que deben ser abordadas para el 2050. ",
      slideEighteenSelectOneChoices: [
        {
          label: "Toda la Región",
          value: "RegionWideNeeds",
          num: 1
        },
        {
          label: "New Mexico",
          value: "NewMexicoNeeds",
          num: 2
        },
        {
          label: "West Valley",
          value: "WestValleyNeeds",
          num: 3
        },
        {
          label: "Northeast El Paso",
          value: "NorthEastNeeds",
          num: 4
        },
        {
          label: "Central El Paso",
          value: "CentralNeeds",
          num: 5
        },
        {
          label: "Central East El Paso",
          value: "CentralEastNeeds",
          num: 6
        },
        {
          label: "Mission Valley",
          value: "MissionValleyNeeds",
          num: 7
        },
        {
          label: "Far East El Paso / El Paso County",
          value: "FarEastNeeds",
          num: 8
        }
      ],
      slideEighteenSelectTwoQuestionPartOne: "Si usted respondió",
      slideEighteenSelectTwoQuestion:
        "¿qué tipos de necesidades deberían abordarse en toda la región?",
      slideEighteenSelectTwoLabelPartOne:
        " ¿qué tipo de necesidades tiene la subárea de",
      slideEighteenSelectTwoLabelPartTwo: "?",
      slideEighteenSelectTwoChoices: [
        { label: "Congestión vial", value: "Congestion" },
        { label: "Acceso peatonal", value: "Pedestrian access" },
        { label: "Acceso para bicicletas", value: "Bicycle access" },
        { label: "Ferrocarril interurbano", value: "Intercity rail" },
        { label: "Seguridad", value: "Safety" },
        {
          label: "Disponibilidad de transporte público/ calidad de servicio",
          value: "Transit availability / service quality"
        },
        { label: "Bus interurbano ", value: "Intercity bus" },
        {
          label: "Cruces fronterizos adicionales",
          value: "Additional border crossings"
        },
        {
          label: "Conservación del derecho de vía",
          value: "Rights-of-way preservation"
        },
        {
          label: "Acceso al /expansión del cruce fronterizo",
          value: "Border crossing access / expansion"
        },
        {
          label: "Servicios de transporte de pasajeros",
          value: "Ride hailing services"
        },
        {
          label: "Gestión de aguas pluviales / drenaje",
          value: "Stormwater management / drainage"
        },
        { label: "Viajes aéreos", value: "Air travel" },
        {
          label: "Coordinación del uso del suelo y el transporte",
          value: "Land use - transportation coordination"
        },
        {
          label: "Acceso a instalaciones de carga",
          value: "Freight facility access"
        },
        { label: "Otro", value: "Other" },
        { label: "Ninguno de los anteriores", value: "None of the above" }
      ],

      // Slide Nineteen
      slideNineteenTitle:
        "Utilice este campo de texto para informarnos sobre cualquier otro cambio que considere necesario para el sistema de transporte.",
      slideNineteenTextAreaLabel: "Cuéntenos sus necesidades",

      // Slide Twenty
      slideTwentyTitle: "¡Ha terminado!",
      slideTwentyCompleteWorkshopInstructions:
        'Para enviar su opinión, por favor presione "COMPLETAR EL TALLER."',
      slideTwentyHowWasExperienceInfo:
        "Háganos saber cómo fue su experiencia con el taller.",
      slideTwentyHowWasExperienceBtn: "¿CÓMO FUE SU EXPERIENCIA?",

      slideTwentyExtraCommentTitle: "Envíe otros comentarios o preguntas",
      slideTwentyEmail: "Correo electrónico ",
      slideTwentyMail: "Correo postal - El Paso MPO, Atención:",
      slideTwentyPhone: "Teléfono",
      slideTwentyLastBullet:
        "O, envíe su comentario/pregunta usando el campo de texto a continuación",

      slideTwentyCompleteWorkshopBtn: "COMPLETAR EL TALLER",
      // CommentForm
      slideTwentyOptInLabel:
        "Me gustaría proporcionar mi información para ser contactado en el futuro por el MPO de El Paso.",
      slideTwentyWillNotShareText:
        "La información que proporcione no será compartida.",
      slideTwentyCommentFieldLabel: "Comentario",
      slideTwentyFirstNameLabel: "Primer Nombre",
      slideTwentyLastNameLabel: "Apellido",
      slideTwentyEmailLabel: "Correo electrónico",
      slideTwentyPhoneLabel: "Número de teléfono",
      slideTwentyAddressLabel: "Dirección",
      // How was experience
      slideTwentyCommentLabel: "Escriba su comentario aquí",
      slideTwentyQuestionOne:
        "Los problemas técnicos fueron un problema e inhibieron mi participación.",
      slideTwentyQuestionOneHint: "Technical issues comment",
      slideTwentyQuestionTwo:
        "El formato del taller fue fácil de seguir. (1: Fuertemente en desacuerdo, 5: Fuertemente de acuerdo)",
      slideTwentyQuestionThree:
        "El propósito de este taller me quedó claro. (1: Totalmente en desacuerdo, 5: Totalmente de acuerdo)",
      slideTwentyQuestionFour: "¿Cómo se enteró de este taller?",
      slideTwentyQuestionFourSelectChoices: [
        { label: "Por correo electrónico", value: "Email" },
        { label: "De boca a boca", value: "Word of Mouth" },
        {
          label: "Por un funcionario público electo",
          value: "Through an elected offiical"
        },
        { label: "Folleto", value: "A flyer" },
        { label: "Twitter", value: "Twitter" },
        { label: "Facebook", value: "Facebook" },
        { label: "Periódico", value: "Newspaper" },
        { label: "Radio", value: "Radio" },
        { label: "Televisión", value: "TV" }
      ],
      slideTwentyQuestionFourSelectHint: "¿Cómo se enteró?",
      slideTwentyQuestionFourCommentHint: "¿Cómo se enteró?",
      slideTwentyQuestionFive:
        "La información y los datos proporcionados durante el taller fueron útiles. (1: Fuertemente en desacuerdo, 5: Fuertemente de acuerdo)",
      slideTwentyQuestionSix:
        "¿Tiene alguna sugerencia que pueda mejorar nuestra difusión para la participación del público o que pueda mejorar el taller en sí?",
      slideTwentyQuestionSixCommentHint: "Comentario de mejoras sugeridas",
      standAloneSurvey: "Ir a encuesta digital"
    }
  }
};
